// Deprecated: HODs are now loaded dynamically from the users store
// This constant is kept for backward compatibility but should not be used
export const DEFAULT_HODS: Array<{ id: number; name: string }> = [];
